import { Star, Quote } from "lucide-react";
import { Section, SectionHeading } from "./service-revops-ui";
import { SectionCta } from "./service-revops-section-cta";
import { gohighlevelConfig as defaultConfig } from "./service-platform-config";
import type { PlatformConfig } from "./service-platform-config";

export function ServiceTestimonials({
  config = defaultConfig,
}: {
  config?: PlatformConfig;
} = {}) {
  const testimonials = config.testimonials;
  return (
    <Section>
      <SectionHeading
        eyebrow={config.testimonialsEyebrow}
        navy={config.testimonialsHeadlineNavy}
        blue={config.testimonialsHeadlineBlue}
      />
      <div className="grid md:grid-cols-3 gap-6">
        {testimonials.map((t) => (
          <div
            key={t.name}
            className="relative rounded-[24px] p-7 overflow-hidden"
            style={{
              background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBFF 100%)",
              border: "1px solid rgba(8,46,103,0.07)",
              boxShadow: "0 14px 40px rgba(8,46,103,0.08)",
            }}
          >
            <Quote
              className="absolute top-5 right-5 w-9 h-9 select-none"
              style={{ color: "rgba(17,143,247,0.10)" }}
            />
            <div className="flex items-center gap-1 mb-4">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={i}
                  className="w-4 h-4"
                  style={{ color: "#27DC5D", fill: "#27DC5D" }}
                />
              ))}
            </div>
            <p
              className="mb-6 relative z-10"
              style={{
                fontSize: "15px",
                lineHeight: 1.6,
                color: "#536B89",
              }}
            >
              &ldquo;{t.text}&rdquo;
            </p>
            <div
              className="mb-5 inline-flex items-baseline gap-2 rounded-full px-4 py-2"
              style={{ background: "#EAF5FF" }}
            >
              <span
                className="font-display font-extrabold"
                style={{
                  fontSize: "22px",
                  color: "#0B7CF2",
                  letterSpacing: "-0.03em",
                }}
              >
                {t.metric}
              </span>
              <span
                className="font-sans font-bold uppercase"
                style={{
                  fontSize: "10px",
                  color: "#0B7CF2",
                  letterSpacing: "0.08em",
                }}
              >
                {t.metricLabel}
              </span>
            </div>
            <div className="flex items-center gap-3">
              <div
                className="w-11 h-11 rounded-full overflow-hidden shrink-0"
                style={{ border: "2px solid rgba(11,124,242,0.20)" }}
              >
                <img
                  src={t.image}
                  alt={`Portrait of ${t.name}`}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div
                  className="font-display font-bold"
                  style={{
                    fontSize: "15px",
                    color: "#071E61",
                    letterSpacing: "-0.02em",
                  }}
                >
                  {t.name}
                </div>
                <div
                  className="font-sans"
                  style={{ fontSize: "12px", color: "#6A7D97" }}
                >
                  {t.title}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <SectionCta
        variant="soft"
        copy={config.testimonialsCtaCopy}
        label={config.testimonialsCtaLabel}
      />
    </Section>
  );
}
